const styles = theme => ({
  '@keyframes slideDown': {
    from: {
      opacity: 0,
      transform: 'translateY(-10px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#F7F8FA',
    height: 'fit-content',
    width: '100%',
    gap: '16px',
    minHeight: '100%',
  },
  cardTitle: {
    fontSize: '24px',
    fontWeight: 600,
    color: '#212B36',
    textAlign: 'center',
    marginBottom: '24px',
    maxWidth: '600px',
    lineHeight: '1.4',
  },
  limitModalWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '600px',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: '12px',
    padding: '16px',
    margin: '36px auto',
    backgroundColor: '#fff',
    flexDirection: 'column',
  },
  body: {
    maxWidth: '672px',
    margin: '0 auto',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '16px',
  },
  title: {
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 500,
  },
  courseInfo: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '12px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  outlineSection: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '16px',
  },
  generateOutlineButton: {
    height: '56px',
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    },
    '&:disabled': {
      backgroundColor: '#E0E3E7',
      color: '#637381',
      cursor: 'not-allowed',
    },
  },
  outlineErrorContainer: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '16px',
    marginTop: '16px',
  },
  outlineResult: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '16px',
  },
  outlineHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  outlineTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#212B36',
    margin: 0,
  },
  resetOutlineButton: {
    fontSize: '12px',
    padding: '4px 12px',
    minWidth: 'auto',
  },
  outlineContent: {
    backgroundColor: '#F8F9FA',
    borderRadius: '8px',
    padding: '16px',
    border: '1px solid #E0E3E7',
    '& pre': {
      margin: 0,
      fontSize: '14px',
      lineHeight: '1.5',
      color: '#637381',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
    },
  },
  outlineText: {
    fontSize: '14px',
    lineHeight: '1.6',
    color: '#212B36',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  outlineJson: {
    '& pre': {
      margin: 0,
      fontSize: '14px',
      lineHeight: '1.5',
      color: '#637381',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
    },
  },
  outlineError: {
    fontSize: '14px',
    color: '#D32F2F',
    textAlign: 'center',
    padding: '8px',
    backgroundColor: '#FFEBEE',
    borderRadius: '4px',
    border: '1px solid #FFCDD2',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '100px',
  },
})

export default styles
